import React from "react";
import styles from "./style.module.scss";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBListGroup,
  MDBListGroupItem,
  MDBAnimation
} from "mdbreact";
import LazyLoad from "react-lazyload";
import cx from "classnames";
import { Link } from "react-router-dom";
import bocongthuong1 from "~/assets/img/mobile/logo/bocongthuong1.svg";
import bocongthuong2 from "~/assets/img/mobile/logo/bocongthuong2.svg";
import googlePlay from "~/assets/img/common/logo/googleplay.svg";
import appStore from "~/assets/img/common/logo/appstore.svg";
import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";
import {
  urlLogoFooter,
  LINK_ANDROID_APP,
  LINK_IOS_APP
} from "~/utils/manageResource";

const Footer = props => {
  /* --------- INFO------------ */
  const info = get(partnerInfo, "info");
  const nameInfo = find(info, { key: "name" });
  const addressInfo = find(info, { key: "address" });
  const websiteInfo = find(info, { key: "website" });
  const emailInfo = find(info, { key: "email" });
  const phoneInfo = find(info, { key: "phone" });

  /* --------- MENU------------ */
  const menuData = get(partnerInfo, "menuFooter");
  let menuNode = [];
  if (menuData && menuData.length > 0) {
    menuNode = menuData.map((menu, index) => {
      return (
        <MDBListGroupItem key={`${index}-menu-footer`}>
          <Link to={menu.link}>{menu.name}</Link>
        </MDBListGroupItem>
      );
    });
  }
  return (
    <MDBAnimation reveal="true" type="fadeIn" className={styles.footer}>
      <div className={styles.footer_inner}>
        <MDBContainer>
          <MDBRow>
            <MDBCol lg="2">
              <div
                className={styles.footer_item}
                onClick={() => {
                  window.scrollTo(0, 0);
                }}
              >
                <Link to="/">
                  <LazyLoad height={43}>
                    <img
                      src={urlLogoFooter}
                      className={cx("img-fluid", styles.logo_footer)}
                      alt=""
                    />
                  </LazyLoad>
                </Link>
              </div>
            </MDBCol>
            <MDBCol lg="5">
              <div className={styles.footer_item}>
                <MDBListGroup className={styles.item_info}>
                  <MDBListGroupItem>
                    <span href="#" className={styles.textPKH}>
                      <strong>{`${nameInfo.value}`.toUpperCase()}</strong>
                    </span>
                  </MDBListGroupItem>
                  <MDBListGroupItem>
                    <span href="#">
                      {`${addressInfo.displayPrefix} ${addressInfo.value}`}
                    </span>
                  </MDBListGroupItem>
                  <MDBListGroupItem>
                    <a
                      href={websiteInfo.value}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {`${websiteInfo.displayPrefix} ${websiteInfo.value}`}
                    </a>
                  </MDBListGroupItem>
                  <MDBListGroupItem>
                    <span href="#">{`${emailInfo.displayPrefix} ${emailInfo.value}`}</span>
                  </MDBListGroupItem>
                  <MDBListGroupItem>
                    <span href="#">
                      {`${phoneInfo.displayPrefix} ${phoneInfo.value}`}
                    </span>
                  </MDBListGroupItem>
                </MDBListGroup>
              </div>
            </MDBCol>
            <MDBCol lg="2" className="d-none d-lg-block">
              <div className={styles.footer_item}>
                <MDBListGroup className={styles.item_info}>
                  {menuNode}
                </MDBListGroup>
              </div>
            </MDBCol>
            <MDBCol lg="3">
              <div className={styles.footer_item}>
                <MDBListGroup className={cx(styles.item_info, styles.icons)}>
                  <MDBListGroupItem>
                    <a
                      href="http://online.gov.vn/Home/WebDetails/44668"
                      // eslint-disable-next-line react/jsx-no-target-blank
                      target="_blank"
                      title="Bộ công thương"
                      rel="noopener noreferrer"
                    >
                      <LazyLoad height={50}>
                        <img src={bocongthuong1} alt="" />
                      </LazyLoad>
                    </a>
                  </MDBListGroupItem>
                  <MDBListGroupItem>
                    <a
                      href="http://online.gov.vn/Home/WebDetails/44209"
                      // eslint-disable-next-line react/jsx-no-target-blank
                      target="_blank"
                      title="Bộ công thương"
                      rel="noopener noreferrer"
                    >
                      <LazyLoad height={50}>
                        <img src={bocongthuong2} alt="" />
                      </LazyLoad>
                    </a>
                  </MDBListGroupItem>
                  <MDBListGroupItem>
                    <a
                      href={LINK_ANDROID_APP}
                      alt="apple-app-icon"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <LazyLoad height={50}>
                        <img src={googlePlay} alt="" />
                      </LazyLoad>
                    </a>
                  </MDBListGroupItem>
                  <MDBListGroupItem>
                    <a
                      href={LINK_IOS_APP}
                      alt="apple-app-icon"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <LazyLoad height={50}>
                        <img src={appStore} alt="" />
                      </LazyLoad>
                    </a>
                  </MDBListGroupItem>
                </MDBListGroup>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
      <div className={styles.footer_copy_right}>
        <MDBContainer>
          <MDBRow>
            <MDBCol size="12">
              <div className={styles.footer_item}>
                © 2020 - Bản quyền thuộc Công Ty Cổ Phần Ứng Dụng PKH
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    </MDBAnimation>
  );
};

export default Footer;
